import { useEffect, useMemo, useState } from 'react';
import { Select } from 'antd';
import * as Flags from 'country-flag-icons/react/3x2';
import classnames from 'classnames';

import { CUSTOM_LABELS, ENABLE_COUNTRY } from 'static/Constants';
import CountryCode from 'static/CountryCode';

import './FlagCountrySelectionFieldInput.less';

const DEFAULT_PLACEHOLDER = 'Select a country';

const FlagCountrySelectionFieldInput = (props) => {
  const {
    value,
    className,
    defaultCountry,
    isLanguage = false,
    searchable = false,
    placeholder,
    onSelect,
    // value is written back by the caller through onSelect + setFieldsValue,
    // so the onChange injected by Form.Item is intentionally not forwarded
    onChange,
    ...restProps
  } = props;

  // keeps the user's pick visible when the caller does not feed it back via value
  const [pickedCode, setPickedCode] = useState(null);

  useEffect(() => {
    setPickedCode(null);
  }, [value, defaultCountry]);

  const procValue = useMemo(() => {
    if (!value) return defaultCountry || null;

    if (value && value?.length > 2) {
      const labelDefine = isLanguage ? CUSTOM_LABELS : CountryCode;
      return Object.keys(labelDefine).find(
        (labelKey) => labelDefine[labelKey] === value
      );
    }

    return value;
  }, [value, defaultCountry, isLanguage]);

  const options = useMemo(() => {
    const codes = isLanguage ? ENABLE_COUNTRY : Object.keys(CountryCode);
    const labels = isLanguage ? CUSTOM_LABELS : CountryCode;

    return codes
      .filter((code) => Flags[code])
      .map((code) => {
        const Flag = Flags[code];
        return {
          value: code,
          name: labels[code],
          label: (
            <span className='flag-country-selection-field-input__option'>
              <Flag className='flag-country-selection-field-input__flag' />
              <span className='flag-country-selection-field-input__label'>
                {labels[code]}
              </span>
            </span>
          ),
        };
      });
  }, [isLanguage]);

  const filterOption = (input, option) =>
    (option?.name || '').toLowerCase().includes(input.toLowerCase());

  return (
    <Select
      className={classnames('flag-country-selection-field-input', className)}
      dropdownClassName='flag-country-selection-field-input__dropdown'
      // render inline (like the previous library) so the list scrolls with the form/modal
      getPopupContainer={(trigger) => trigger.parentNode}
      value={pickedCode || procValue || undefined}
      options={options}
      showSearch={searchable}
      filterOption={filterOption}
      placeholder={placeholder || DEFAULT_PLACEHOLDER}
      onSelect={(code) => {
        setPickedCode(code);
        onSelect && onSelect(code);
      }}
      {...restProps}
    />
  );
};

export default FlagCountrySelectionFieldInput;
